// Types
import mixins from "vue-typed-mixins";
// Mixins
import { WithPartialInject } from '../../utils/withInject';
import NavigationItemsProvider from '../../mixins/NavigationItemsProvider';
import ControllerBase from '../../mixins/ControllerBase';
const ControllerNavigationBar = mixins(ControllerBase, WithPartialInject('controllerHeader'), NavigationItemsProvider).extend({
  name: 'ControllerNavigationBar',
  watch: {
    'controllerHeader.navigationItems': {
      immediate: true,
      handler(v) {
        const n = this.navigationItems;
        n.splice(0, n.length, ...v);
      }
    }
  },
  render() {
    var _this$controllerHeade;
    const items = ((_this$controllerHeade = this.controllerHeader) === null || _this$controllerHeade === void 0 ? void 0 : _this$controllerHeade.navigationItems) || [];
    const slotProps = items.map(item => ({
      item
    }));
    return this.renderContainer(slotProps, undefined, 'Main navigation');
  }
});
export default ControllerNavigationBar;